const LEGACY_TRUNCATED_SUMMARY_LENGTH = 320;
const CANONICAL_SUMMARY_HARD_LIMIT = 2400;

function normalizeSummaryText(value = "") {
  return String(value || "").replace(/\s+/g, " ").trim();
}

function hasTerminalSentencePunctuation(value = "") {
  return /[.!?](?:["'’”)\]]*)$/.test(normalizeSummaryText(value));
}

function isLikelyLegacyTruncatedSummary(value = "") {
  const normalized = normalizeSummaryText(value);
  return normalized.length === LEGACY_TRUNCATED_SUMMARY_LENGTH &&
    !hasTerminalSentencePunctuation(normalized);
}

function completeSentencePrefix(value = "", hardLimit = CANONICAL_SUMMARY_HARD_LIMIT) {
  const normalized = normalizeSummaryText(value);
  if (!normalized || hardLimit < 1) return "";

  const sentences = normalized
    .split(/(?<=[.!?])\s+/)
    .map((sentence) => normalizeSummaryText(sentence))
    .filter(Boolean);
  let prefix = "";

  for (const sentence of sentences) {
    if (!hasTerminalSentencePunctuation(sentence)) break;
    const candidate = normalizeSummaryText(`${prefix} ${sentence}`);
    if (candidate.length > hardLimit) break;
    prefix = candidate;
  }

  return prefix;
}

function preserveCanonicalSummaryText(
  value = "",
  fallbackValue = "",
  hardLimit = CANONICAL_SUMMARY_HARD_LIMIT
) {
  const candidates = [value, fallbackValue];

  for (const candidate of candidates) {
    const normalized = normalizeSummaryText(candidate);
    if (!normalized || isLikelyLegacyTruncatedSummary(normalized)) continue;
    if (normalized.length <= hardLimit) return normalized;

    const completePrefix = completeSentencePrefix(normalized, hardLimit);
    if (completePrefix) return completePrefix;
  }

  return "";
}

module.exports = {
  CANONICAL_SUMMARY_HARD_LIMIT,
  LEGACY_TRUNCATED_SUMMARY_LENGTH,
  completeSentencePrefix,
  hasTerminalSentencePunctuation,
  isLikelyLegacyTruncatedSummary,
  preserveCanonicalSummaryText,
};
